import { render, staticRenderFns } from "./TifLiquidacionesForm.vue?vue&type=template&id=50f3bea9"
import script from "./TifLiquidacionesForm.vue?vue&type=script&lang=js"
export * from "./TifLiquidacionesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports